import { render } from "./UserEmail.vue?vue&type=template&id=53bc8368&scoped=true"
import script from "./UserEmail.vue?vue&type=script&lang=js"
export * from "./UserEmail.vue?vue&type=script&lang=js"

import "./UserEmail.vue?vue&type=style&index=0&id=53bc8368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bc8368"]])

export default __exports__